<!-- first icon -->
@if (mappedItem.isDescriptiveOnlyCost) {
    <mat-icon class="cb-grey cb-help-cursor" aria-hidden="false" matTooltip="Descriptive Only">
        notes
    </mat-icon>
}
@if (mappedItem.isOwnersCareCost) {
    <mat-icon
        class="mat-accent cb-help-cursor"
        title="Owners care"
        aria-hidden="false"
        matTooltip="Owners Care"
    >
        person
    </mat-icon>
}
@if (mappedItem.isNoChargeCost) {
    <mat-icon class="mat-accent cb-help-cursor" aria-hidden="false" matTooltip="No Charge">
        money_off
    </mat-icon>
}

<!-- second icon -->
@if (mappedItem.offeringStatus === OFFERING_STATUS_ENUM.Active && mappedItem.productId) {
    <mat-icon class="mat-primary cb-help-cursor" aria-hidden="false" matTooltip="Active">
        check_circle
    </mat-icon>
}
@if (
    mappedItem.offeringStatus === OFFERING_STATUS_ENUM.TemporarilyUnavailable &&
    mappedItem.productId
) {
    <mat-icon
        class="mat-warn cb-help-cursor"
        aria-hidden="false"
        matTooltip="Temporarily Unavailable"
    >
        warning
    </mat-icon>
}
@if (
    mappedItem.offeringStatus === OFFERING_STATUS_ENUM.PermanentlyUnavailable &&
    mappedItem.productId
) {
    <mat-icon
        class="cb-error cb-help-cursor"
        aria-hidden="false"
        matTooltip="Permanently Unavailable"
    >
        error
    </mat-icon>
}

<!-- third icon -->
@if (mappedItem.bundleId) {
    <mat-icon class="cb-grey cb-help-cursor" aria-hidden="false" matTooltip="Is part of bundle">
        attach_file
    </mat-icon>
}

<!-- <mat-icon class="cb-help-cursor"
*ngIf="mappedItem.product.productType === PRODUCT_TYPE_ENUM.Bundle"
aria-hidden="false"
matTooltip="Is Bundle">
folder
</mat-icon> -->
@if (mappedItem.quoteRequired || mappedItem.costType === COST_TYPE_ENUM.Quote) {
    <mat-icon class="cb-grey cb-help-cursor" aria-hidden="false" matTooltip="Is Quote">
        description
    </mat-icon>
}
@if (mappedItem.showInClientSpecification) {
    <mat-icon
        class="cb-grey cb-help-cursor"
        aria-hidden="false"
        matTooltip="Included in Flyer / Create Schedule"
    >
        style
    </mat-icon>
}
@if (mappedItem.showInColourYourDreams) {
    <mat-icon
        class="cb-grey cb-help-cursor"
        svgIcon="book-open-page-variant"
        matTooltip="Included in Colour Schedule"
    >
    </mat-icon>
}
@if (mappedItem.isPendingCredit || mappedItem.isPendingDelete || mappedItem.isPendingVariation) {
    <mat-icon class="mat-accent cb-help-cursor" aria-hidden="false" matTooltip="Pending">
        timelapse
    </mat-icon>
}
